import { formatBrDate } from "../../../infra/helpers/date";

export const colunas : any = [
  {
    title: "Data",
    dataIndex: "DataMovimento",
    key: "DataMovimento",
    render(data: any) {
      return formatBrDate(data)
    },
    width: 8,
  },
  {
    title: "Tipo",
    dataIndex: "MovimentoTipo",
    key: "MovimentoTipo",
    filters: [
      {
        text: 'CI - Entrada',
        value: 'CI - Entrada',
      },
      {
        text: 'CI - Saída',
        value: 'CI - Saída',
      },
      {
        text: 'Nota Fiscal',
        value: 'Nota Fiscal',
      },
    ],
    // filterMultiple: false,
    // onFilter: (value: any, record : any) => record.MovimentoTipo.indexOf(value) === 0,
    width: 8,
  },
  {
    title: "Referência",
    dataIndex: "MovimentoCodigoReferencia",
    key: "MovimentoCodigoReferencia",
    width: 8,
  },
  {
    title: "Rack",
    dataIndex: "TouroRack",
    key: "TouroRack",
    width: 8,
  },
  
  {
    id: 'styleProduto',
    title: "Produto",
    dataIndex: "NovoProdutoNome",
    key: "NovoProdutoNome",
    width: 38,
  },
  {
    title: "Raça",
    dataIndex: "TouroRaca",
    key: "TouroRaca",
    width: 8,
  },
  {
    title: "Semen",
    dataIndex: "TouroSemenTipo",
    key: "TouroSemenTipo",
    width: 8,
  },
  {
    title: "Qtde",
    dataIndex: "Quantidade",
    key: "Quantidade",
    align: "right",
    width: 8,
  },
  {
    title: "Observações",
    dataIndex: "Observacoes",
    key: "Observacoes",
  },
]